import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { IoPerson, IoBarChartSharp, IoHome, IoLogOut } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { LogOut, reset } from "../features/authSlice";

const Sidebar = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.auth);

    const logout = () => {
        dispatch(LogOut());
        dispatch(reset());
        localStorage.clear();
        navigate("/");
    };

    return (

        <div className="column is-3 pl-5">
            <aside className="menu is-hidden-mobile">
                <p className="menu-label">
                    General
                </p>
                <ul className="menu-list">
                    <li><NavLink to={"/dashboard"}><IoHome className="mr-1" />Dashboard</NavLink></li>
                    <li><NavLink to={"/sensors"}><IoBarChartSharp className="mr-1" />Report</NavLink></li>
                    {user && user.role === "admin" && (
                        <li><NavLink to={"/users"}><IoPerson className="mr-1" />Users</NavLink></li>
                    )}
                </ul>
                <p className="menu-label">
                    Option
                </p>
                <ul className="menu-list">
                    <li>
                        <button onClick={logout} className="button is-success" >
                            <IoLogOut className="mr-1" /> Logout
                        </button>
                    </li>
                </ul>

            </aside>
        </div>



    );
};

export default Sidebar;